import { graphql, PageProps, useStaticQuery } from 'gatsby'

import React, { ReactElement } from 'react'
import { BuilderPageRenderer, PageData } from 'src/pages/builder';

const BuilderPage = (props: PageProps): ReactElement => {
  const data: PageData = useStaticQuery(graphql`{
    contentfulPage(contentful_id: {eq: "382wfkjgH0xjMZ2AV69d7X"}) {
      title
      seoTitle
      seoDescription
      seoImage {
        file {
          url
        }
      }
      contentfulchildren {
        id
        label
        contentfulchildren {
          ...HeroBannerContent
          ...HeadingContent
          ...ButtonContent
          ...TrustedClientsContent
          ...PhoneCarouselContent
          ...FeaturesContent
          ...SliderContent
        }
      }
    }
  }
  `)

  return (
    <BuilderPageRenderer {...props} data={data} />
  )
}

export default BuilderPage;
